import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import AudioPlayer from "react-h5-audio-player"
import ReactMapGL, {
  Marker,
  NavigationControl,
  FlyToInterpolator,
  Popup,
} from "react-map-gl"
import "mapbox-gl/dist/mapbox-gl.css"
import { fromJS } from "immutable"
import Player from "./player"
import SideImage from "./side-image"

const ICON = "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"

// `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
//   c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
//   C20.1,15.8,20.2,15.8,20.2,15.7z`

const pinStyle = {
  cursor: "pointer",
  fill: "#E45A22",
  stroke: "none",
}

const Pin = ({ size, onClick }) => (
  <svg
    height={size}
    viewBox="0 0 24 24"
    style={{
      ...pinStyle,
      transform: `translate(${-size / 2}px,${-size}px)`,
    }}
    onClick={onClick}
  >
    <path d={ICON} />
  </svg>
)

const initalViewPort = {
  latitude: -26.1928947,
  longitude: 28.0326519,
  zoom: 10,
  pitch: 45,
  width: "100%",
  height: 400,
}
//-26.1928947,28.0326519
const Episode = ({ content, next, prev, showNext, showPrev }) => {
  const [viewPort, setViewPort] = useState({
    ...initalViewPort,
    zoom: content.start.zoom,
    latitude: parseFloat(content.start.lat),
    longitude: parseFloat(content.start.long),
  })
  const [popupInfo, setPopupInfo] = useState(null)
  const [currentImage, setCurrentImage] = useState(content.start.image.id)
  const [episodeStarted, setEpisodeStarted] = useState(false)
  return (
    <div className="container">
      <div
        className="columns is-desktop"
        style={{ marginTop: 0, marginBottom: 0 }}
      >
        <div className="column player-background is-half-desktop is-full-tablet is-full-mobile episode-stuff" style={{paddingTop: '1.5rem'}}>
          <div>
          <h2 className="title is-3 header-font" style={{paddingTop: '1rem'}}>{content.name}</h2>
          <Player
            url={content.track}
            name={content.name}
            intervalEvent={e => {
              setEpisodeStarted(true)
              content.locations.forEach(a => {
                if (parseFloat(a.start) < e && parseFloat(a.end) > e) {
                  console.log("change", a.name)
                  setViewPort({
                    ...viewPort,
                    zoom: a.zoom,
                    latitude: parseFloat(a.lat),
                    longitude: parseFloat(a.long),
                    transitionInterpolator: new FlyToInterpolator(),
                    transitionDuration: 1000,
                  })
                  setCurrentImage(a.image.id)
                }
              })

              {
                /* if (e > 4.0) {
                const currentViewPort = viewPort
                setViewPort({
                  ...currentViewPort,
                  latitude: -26.1945666,
                  longitude: 28.0365171,
                  transitionInterpolator: new FlyToInterpolator(),
                  transitionDuration: 1000,
                })

                console.log("greater!!!", viewPort)
              } */
              }
            }}
          />
          {/* <div className="episode-stuff"> */}
          <p className="is-size-5 has-text-justified">{content.description}</p>
          </div>
          <div
            className="columns is-size-5 next-stuff"
            style={{ marginTop: "1rem", marginBottom: "1rem" }}
          >
            <div className="column">
              {showPrev && (
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    prev()
                  }}
                  className="next-link header-font has-text-orange is-bold"
                  style={{ textDecoration: "none" }}
                >
                  <svg
                    viewBox="0 0 32 32"
                    className="icon is-medium has-fill-orange"
                    viewBox="0 0 32 32"
                    aria-hidden="true"
                  >
                    <path d="M20.697 24L9.303 16.003 20.697 8z" />
                  </svg>
                  <span>Previous Episode</span>
                </a>
              )}
            </div>
            <div className="column">
              {showNext && (
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    next()
                  }}
                  className="next-link header-font has-text-orange is-bold is-pulled-right"
                  style={{ textDecoration: "none" }}
                >
                  <span>Next Episode</span>
                  <svg
                    viewBox="0 0 32 32"
                    className="icon is-medium has-fill-orange"
                    viewBox="0 0 32 32"
                    aria-hidden="true"
                  >
                    <path d="M11.303 8l11.394 7.997L11.303 24z" />
                  </svg>
                </a>
              )}
            </div>
          {/* </div> */}
          </div>
        </div>
        <div className="column player-background is-marginless is-paddingless is-half-desktop is-full-tablet is-full-mobile side-image">
          <div>
            <SideImage imageId={currentImage} />
          </div>
        </div>
      </div>

      <div className="columns" style={{ marginTop: 0 }}>
        <div className="column" style={{ padding: 0 }}>
          <ReactMapGL
            {...viewPort}
            mapboxApiAccessToken={
              "pk.eyJ1IjoicnVubmluZ2RldmVsb3BlciIsImEiOiJjanluYWw4aWYwcHJqM2NxZHQ0anZlaXc2In0.-l6T34HYpzv1F99aH9dGOg"
            }
            //mapStyle={'mapbox://styles/mapbox/streets-v11'} mapbox://styles/runningdeveloper/cjyoqiesh095n1cqq51b1vlys
            mapStyle={"mapbox://styles/mapbox/streets-v11"}
            onViewportChange={viewport => {
              const { width, height, latitude, longitude, zoom } = viewport
              setViewPort(viewport)
            }}
          >
            {/* {popupInfo && (
              <Popup
                tipSize={10}
                anchor="top"
                longitude={parseFloat(popupInfo.long)}
                latitude={parseFloat(popupInfo.lat)}
                closeOnClick={false}
                onClose={() => setPopupInfo(null)}
              >
                <div>
                  <p>{popupInfo.name}</p>
                </div>
              </Popup>
            )} */}
            {!episodeStarted && <>
              <Marker
                key={`start`}
                latitude={parseFloat(content.start.lat)}
                longitude={parseFloat(content.start.long)}
              >
                <Pin size={40}/>
              </Marker>
              <Popup
                tipSize={10}
                anchor="top"
                longitude={parseFloat(content.start.long)}
                latitude={parseFloat(content.start.lat)}
                closeButton={false}
              >
                <div>
                  <b>{content.start.name}</b>
                  <p>{content.start.text}</p>
                </div>
              </Popup>
              </>
            }

            {episodeStarted && content.locations.map(a => (<>
              <Marker
                key={a.name}
                latitude={parseFloat(a.lat)}
                longitude={parseFloat(a.long)}
              >
                <Pin size={40} />
              </Marker>
              <Popup
                tipSize={10}
                anchor="top"
                longitude={parseFloat(a.long)}
                latitude={parseFloat(a.lat)}
                closeButton={false}
              >
                <div>
                  <p>{a.name}</p>
                </div>
              </Popup>
              </>
            ))}
          </ReactMapGL>
        </div>
      </div>
      {/* <LoadScript
        id="script-loader"
        googleMapsApiKey={googleapi}
      ><>
      <GoogleMap
    id="circle-example"
    mapContainerStyle={{
      height: "400px",
      width: "800px"
    }}
    zoom={10}
    center={{
      lat:  -26.1885591,
        lng: 28.0427963
    }}
  >
    <StreetViewPanorama
      position={{
        lat:  -26.1885591,
        lng: 28.0427963
      }}
      visible={true}
      onCloseclick={()=>{console.log('hey')}}
    />
  </GoogleMap>

  <GoogleMap
    id="marker-example2"
    mapContainerStyle={{
      height: "400px",
      width: "800px"
    }}
    zoom={8}
    center={aPosition}
  >
    <GoogleMarker
      onLoad={marker => {
        console.log('marker: ', marker)
      }}
      position={{
        lat: 37.772,
        lng: -122.214
      }}
    />
  </GoogleMap>
  </>
      </LoadScript> */}
    </div>
  )
}

export default Episode
